function handleClickOnCTA() {
  const tabs = [...document.querySelectorAll('.js-cta')]
  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      const moreInfoNode = tab.previousElementSibling
      tab.classList.toggle('is-opened')
      if (moreInfoNode.classList.contains('js-more-info')) {
        moreInfoNode.classList.toggle('c-business--hidden')
      }
    })
  })
}

export default handleClickOnCTA
